import { useCallback } from 'react';
import { utcToZonedTime } from 'date-fns-tz';
import { useBusinessHoursProps } from '../../business-hours-props-context';

export function useCurrentDateInTimezoneGetter() {
  const { timeZone } = useBusinessHoursProps();

  return useCallback(
    () => (timeZone ? utcToZonedTime(new Date(), timeZone) : new Date()),
    [timeZone]
  );
}
